import {Injectable, TemplateRef} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {

  // tslint:disable-next-line:variable-name
  private _data: BehaviorSubject<any> = new BehaviorSubject(null);

  public get Data(): Observable<{ tpl: TemplateRef<any>, templateTitle: string }> {
    return this._data.asObservable();
  }
  constructor() {
  }

  SetData(data: { tpl: TemplateRef<any>, templateTitle: string }): void {
    this._data.next(data);
  }
}
